export const PLACEHOLDER_OFFICE_NAME = '{{office_name}}'
export const PLACEHOLDER_LOCATION = '{{location}}'

export const PLACEHOLDERS = [PLACEHOLDER_OFFICE_NAME, PLACEHOLDER_LOCATION]

const PLACEHOLDER_REGEX = /\{\{(office_name|location)\}\}/g

export function getUsedPlaceholders(text) {
  if (!text) return []

  const matches = text.match(PLACEHOLDER_REGEX) || []
  return [...new Set(matches)]
}

export function getPlaceholderValue(company, placeholder) {
  if (!company) return ''

  if (placeholder === PLACEHOLDER_OFFICE_NAME) {
    return company.name?.trim() || ''
  }

  if (placeholder === PLACEHOLDER_LOCATION) {
    return company.address?.city?.trim() || ''
  }

  return ''
}

export function getOfficesWithMissingPlaceholders(text, offices) {
  const usedPlaceholders = getUsedPlaceholders(text)
  if (!usedPlaceholders.length || !offices?.length) return []

  return offices.filter((office) =>
    usedPlaceholders.some((placeholder) => !getPlaceholderValue(office, placeholder))
  )
}
